import {AfterViewChecked, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {User} from '../datamodel/user';

declare var $;

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.css']
})
export class BadgeComponent implements OnInit, AfterViewChecked {

  @Input()
  user: User;

  @ViewChild('badge', {static: true}) el: ElementRef;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewChecked(): void {
    $(this.el.nativeElement).usosBadge({
      entity: 'entity/users/user',
      user_id: this.user.id
    });
  }

}
